import request from '../utils/request';
import { buildApiPayload } from '../utils/api';

export function getTablets(params, signal) {
  return request({
    url: '/tablets/list',
    method: 'get',
    data: params,
    signal,
  });
}

export function getTablet(uuid, params) {
  return request({
    url: `/tablets/${uuid}`,
    method: 'get',
    data: params,
  });
}

export function getTabletLogs(params) {
  return request({
    url: '/tablets/s3/logs',
    method: 'get',
    data: buildApiPayload({ payload: params, dateEndKeys: ['endTime'] }),
  });
}

export function getTabletLogDetails(uuid) {
  return request({
    url: `/tablets/s3/logs/${uuid}`,
    method: 'get',
  });
}

export function deleteTablet(uuid, params) {
  return request({
    url: `/tablets/${uuid}`,
    method: 'delete',
    data: params,
  });
}

export function deleteTabletLog(uuid, params) {
  return request({
    url: `/tablets/s3/logs/${uuid}`,
    method: 'delete',
    data: params,
  });
}

export function getTabletsModels(params) {
  return request({
    url: '/tablets/models',
    method: 'get',
    data: params,
  });
}

export function getTabletsBuilds(params) {
  return request({
    url: '/tablets/builds',
    method: 'get',
    data: params,
  });
}

export function changeTabletName(uuid, params) {
  return request({
    url: `/tablets/name/${uuid}`,
    method: 'put',
    data: params,
  });
}

export function changeTabletState(uuid, params) {
  return request({
    url: `/tablets/command/${uuid}`,
    method: 'post',
    data: params,
  });
}

export function getTabletsStreamNames() {
  return request({
    url: '/tablets/command/zones/stream',
    method: 'get',
  });
}

export function getTabletsAvailability(params, signal) {
  return request({
    url: '/availability/tablets',
    method: 'get',
    data: buildApiPayload({ payload: params, dateEndKeys: ['endTime'] }),
    signal,
  });
}

export function getTabletSessions(tabletUuid) {
  return request({
    url: '/tablet-sessions',
    method: 'get',
    data: { tabletUuid },
  });
}

export function deleteTabletSessions(tabletUuid) {
  return request({
    url: '/tablet-sessions',
    method: 'delete',
    data: { tabletUuid },
  });
}

export function changeTabletRemoteAccess(uuid, params) {
  return request({
    url: `/tablets/${uuid}/remote-access`,
    method: 'put',
    data: params,
  });
}

export function getTabletSettings(uuid, params) {
  return request({
    url: `/tablets/${uuid}/settings`,
    method: 'get',
    data: params,
  });
}

export function putTabletSettings(uuid, params) {
  return request({
    url: `/tablets/${uuid}/settings`,
    method: 'put',
    data: params,
  });
}

export function uploadTabletLogs(uuid, params) {
  return request({
    url: `/tablets/${uuid}/actions/upload-logs`,
    method: 'post',
    data: params,
  });
}

export function takeTabletScreenshot(uuid, params) {
  return request({
    url: `/tablets/${uuid}/actions/screenshot`,
    method: 'post',
    data: params,
  });
}

export function getScreenshots(uuid, params) {
  return request({
    url: `/tablets/${uuid}/screenshots`,
    method: 'get',
    data: buildApiPayload({ payload: params, dateEndKeys: ['endTime'] }),
  });
}

export function getScreenshot(uuid, fileUuid) {
  return request({
    url: `/tablets/${uuid}/screenshots/${fileUuid}`,
    method: 'get',
    responseType: 'blob',
  });
}

export function deleteScreenshot(tabletUuid, uuid) {
  return request({
    url: `/tablets/${tabletUuid}/screenshots/${uuid}`,
    method: 'delete',
  });
}

export function restart(uuid) {
  return request({
    url: `/tablets/${uuid}/actions/restart`,
    method: 'post',
  });
}

export function watchTabletStream(uuid, streamName) {
  return request({
    url: `/tablets/${uuid}/actions/watch-stream?streamName=${streamName}`,
    method: 'post',
  });
}
